import * as yup from 'yup';

export const schema = yup.object({
  ambiente: yup.object().shape({
    label: yup.string().required(),
    value: yup.number().required(),
  }),
});
